import type * as core from '../../../../../../../core'

/* eslint-disable sort-keys */
export const query: core.mosaic.Widget.Query = {
  selection: {
    '{}': {
      name: 'Innovation Assets',
      type: 'table',
      content: {
        '{}': {
          query: {
            '`': {
              target: 'ent:!innovation_assets:!innovation_asset',
              selection: {
                '{}': {
                  fields: {
                    '{}': {
                      id: {
                        '{}': {
                          value: {
                            '@.': '!id',
                          },
                        },
                      },
                      code: {
                        '{}': {
                          value: {
                            '@.': '!code',
                          },
                        },
                      },
                      name: {
                        '{}': {
                          value: {
                            '@.': '!name',
                          },
                        },
                      },
                      notes: {
                        '{}': {
                          value: {
                            '@.': '!notes',
                          },
                        },
                      },
                      offering: {
                        '{}': {
                          value: {
                            '@': 'offering',
                          },
                        },
                      },
                      aiEnabled: {
                        '{}': {
                          value: {
                            '@.': '!ai_enabled',
                          },
                        },
                      },
                      swagImpact: {
                        '{}': {
                          value: {
                            '@.': '!swag_impact',
                          },
                        },
                      },
                      description: {
                        '{}': {
                          value: {
                            '@.': '!descr',
                          },
                        },
                      },
                      organization: {
                        '{}': {
                          value: {
                            '@': 'organization',
                          },
                        },
                      },
                      pilotProject: {
                        '{}': {
                          value: {
                            '@': 'pilotProject',
                          },
                        },
                      },
                      laneOfSupport: {
                        '{}': {
                          value: {
                            '@.': '!lane_of_support',
                          },
                        },
                      },
                    },
                  },
                },
              },
              subqueries: {
                offering: {
                  ref: {
                    attr: 'attr:ent#!innovation_asset_offering#!entry:!offering',
                  },
                  using: 'assetOffering',
                  target: 'dim::!offerings',
                  quantity: 1,
                  selection: {
                    '@.': '!name',
                  },
                },
                orgOffering: {
                  ref: {
                    attr: 'attr:ent#!org_offering#!entry:!offering',
                    inherit: '-',
                  },
                  using: 'offering',
                  target: 'dim::!org_offering',
                },
                organization: {
                  ref: {
                    attr: 'attr:ent#!org_offering#!entry:!org',
                    inherit: '-',
                  },
                  using: 'orgOffering',
                  target: 'dim::!org',
                  quantity: 1,
                  selection: {
                    '@.': '!name',
                  },
                },
                pilotProject: {
                  ref: {
                    attr: 'attr:ent#!innovation_assets#!innovation_asset:!pilot_proj',
                  },
                  target: 'dim::!projects',
                  quantity: 1,
                  selection: {
                    '@.': '!name',
                  },
                },
                assetOffering: {
                  ref: {
                    attr: 'attr:ent#!innovation_asset_offering#!entry:!innovation_asset',
                  },
                  target: 'dim::!innovation_asset_offering',
                },
              },
            },
          },
          columns: {
            '[]': [
              {
                '{}': {
                  id: 'id',
                  direct: {
                    '{}': {
                      name: 'ID',
                      type: 'TEXT',
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'code',
                  direct: {
                    '{}': {
                      name: 'Code',
                      type: 'TEXT',
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'name',
                  direct: {
                    '{}': {
                      name: 'Name',
                      type: 'TEXT',
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'description',
                  direct: {
                    '{}': {
                      name: 'Description',
                      type: 'TEXT',
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'organization',
                  direct: {
                    '{}': {
                      name: 'Organization',
                      type: 'TEXT',
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'offering',
                  direct: {
                    '{}': {
                      name: 'Offering',
                      type: 'TEXT',
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'laneOfSupport',
                  direct: {
                    '{}': {
                      name: 'Lane of Support',
                      type: 'TEXT',
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'notes',
                  direct: {
                    '{}': {
                      name: 'Notes',
                      type: 'TEXT',
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'aiEnabled',
                  direct: {
                    '{}': {
                      name: 'AI Enabled',
                      type: 'BOOL',
                    },
                  },
                  isSortable: true,
                },
              },

              {
                '{}': {
                  id: 'pilotProject',
                  direct: {
                    '{}': {
                      name: 'Pilot Project',
                      type: 'TEXT',
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'swagImpact',
                  direct: {
                    '{}': {
                      name: 'SWAG Impact',
                      type: 'INT',
                    },
                  },
                  isSortable: true,
                },
              },
            ],
          },
        },
      },
    },
  },
}
